<template>
  <div class="nav">
    <el-row style="min-width: 100%">
      <!-- <el-col style="padding-left: 15.5%"> -->
      <div class="contents" v-sticky="{ zIndex: 100, stickyTop: 50, disabled:false}">
        <p
            class="titleimg"
            style="
              border-bottom: 2px solid #2a67e3;
              line-height: 50px;
              color: #2a67e3;
              margin: 20px 5px 0 5px;
              font-weight: bold;
            "
        >
          {{ contentcolumnText }}
        </p>
        <p
            class="titleimg"
            v-for="(item, index) in contentList"
            :key="index"
            @click="styleIndex = index"
            :class="{ titleimg2: index === styleIndex }"
        >
          <span @click="getContent2(item)">{{ item.columnText }}</span>
          <img
              class="image"
              src="../../assets/scheme/Page3.png"
              alt=""
              v-show="index === styleIndex"
              style="width: 6px; height: 8px"
          />
        </p>
      </div>
      <div class="nav">
        <div class="box-big">
          <div class="top-title">
            <p class="title">产品</p>
            <div class="border"></div>
          </div>
          <div class="text">
            <!-- display: flex; -->
            <div style="width: 100%">
              <el-row class="row-line" style="width: 100%">
                <el-col class="video-row">
                  <div
                      v-for="(item, index) in productList"
                      :key="index"
                      v-if="item.type == selectType || item.type=='敬请期待'"
                      style="width: 50%;text-align: center;vertical-align: top;display: inline-block"
                  >
                    <div class="product-img">
                      <img
                          class="image"
                          :src="item.img"
                          alt=""
                          @click="jump(item)"
                      />
                    </div>
                    <div class="product-content" v-if="item.name!='数字藏品'">
                      <template v-if="item.disabled">
                        <span class="product-options-shelves">{{ item.name }}</span>
                      </template>
                      <template v-else>
                        <el-col>
                          <el-row
                          ><span class="product-title"  @click="jump(item)">{{
                              item.name
                            }}</span></el-row
                          >
                          <el-row
                          ><span class="product-options"  @click="jump(item)">{{
                              item.text
                            }}</span></el-row
                          >
                        </el-col>
                        <!-- <span class="product-title">{{ item.name }}</span>
                        <span class="product-options">{{ item.text }}</span> -->
                      </template>
                    </div>
                    <div class="product-content" v-else>
                      <span class="product-title">{{ item.name }}</span>
                      <div class="product-optionsnum">
                        <div v-for="val in item.url" :key="val.textname" @click="jump(item,val)">{{ val.textname }}</div>
                      </div>
                    </div>
                  </div>
                  <div v-if="selectType!='演示资源'" style="width: 50%;text-align: center;vertical-align: top;display: inline-block">
                    <div class="product-img">
                      <img
                          class="image"
                          :src="require('../../assets/demonstration/logo16.png')"
                          alt=""
                      />
                    </div>
                    <div class="product-content">
                      <span class="product-options-shelves">敬请期待</span>
                    </div>
                  </div>
                </el-col>
              </el-row>
            </div>
          </div>
        </div>
      </div>
    </el-row>
  </div>
</template>

<script>
import img1 from "../../assets/demonstration/logo11.png";
import img2 from "../../assets/demonstration/logo12.png";
import img3 from "../../assets/demonstration/logo13.png";
import img4 from "../../assets/demonstration/logo14.png";
import img5 from "../../assets/demonstration/logo15.png";
import img6 from "../../assets/demonstration/logo16.png";
import img7 from "../../assets/demonstration/logo7.png";
import img8 from "../../assets/demonstration/logo8.png";
import img9 from "../../assets/demonstration/logo9.png";
import img10 from "../../assets/demonstration/img10.png";
import axios from "axios";
import VueSticky from "vue-sticky";

export default {
  name: "product-app.vue",
  data() {
    return {
      selectType:"",
      contentcolumnText: "",
      contentList: [],
      styleIndex: 0,
      productList: [
        {name: '兆票', text: "区块链供应链金融平台", img: img1, url: "http://mtf.trilliontrust.com/",type:"区块链应用平台"},
        {name: '兆融', text: "区块链数据价值融通服务平台", img: img2, url: "http://contract.trilliontrust.com/",type:"区块链应用平台"},
        {name: '兆存', text: "区块链数据存证平台", img: img5, url: "http://profile.trilliontrust.com/",type:"区块链应用平台"},
        {name: '智信链+', text: "区块链BAAS平台V4.0", img: img5, url: "http://mt.trilliontrust.com/",type:"区块链平台"},
        {name: '智信链+', text: "区块链BAAS平台V3.0", img: img5, url: "http://baas.chenhaninfo.com/",type:"区块链平台"},
        {name: '智信链+', text: "区块链BAAS平台V2.0", img: img5, url: "http://dmgmt.trilliontrust.com/",type:"区块链平台"},
        {name: 'MPDM', text: "区块链隐私计算数据服务平台", img: img4, url: "http://mpdatatrading.trilliontrust.com/",type:"隐私计算平台"},
        {name: 'MPDI', text: "区块链隐私计算数据服务管理平台", img: img4, url: "http://mpdatatrading-admin.trilliontrust.com/",type:"隐私计算平台"},
        {name: 'StorNet', text: "区块链分布式存储网络", img: img4, url: "http://dstorenet.trilliontrust.com/",type:"区块链平台"},
        {
          name: '铁证网',
          text: "一站式电子证据平台",
          img: img2,
          url: "http://www.tiezhengwang.com/",
          routerName: "hncrpt",
          type:"区块链应用平台",
        },
        {name: '智能体', text: "数据智能信息系统", img: img4, url: "http://info.trilliontrust.com/",type:"群体智能"},
        {name: '舆情', text: "舆情监测平台", img: img2, url: "http://yuqing.chenhaninfo.com/",type:"群体智能"},
        // {name: 'MT大屏演示', text: "国产自主可控高性能", img: img3, url: ""},
        {name: '兆训', text: "区块链教学实训平台", img: img8, url: "http://mttrain.trilliontrust.com/",type:"区块链应用平台"},
        {name: '演示资源下载', text: "产品演示资源", img: img5, url: 'http://files.trilliontrust.com/演示文档数据地址.docx',type:"演示资源"},
        {name: '数字藏品', text: '', img: img4, url: [{textname:'管理端',texturl:'https://pk-admin.trilliontrust.com/'},{textname:'h5',texturl:'https://pk-h5.trilliontrust.com/pages/home/home'}],type:"区块链应用平台"},
      ],
    };
  },
  directives: {
    'sticky': VueSticky,
  },
  created() {
    this.getList(this.$route.query.item);
    this.contentcolumnText = this.$route.query.item;
  },
  watch: {
    $route: {
      immediate: true,
      handler() {
        if (this.$route.query.text) {
          //需要监听的参数
          this.getList(this.$route.query.item);
          this.styletext = this.$route.query.text;
          this.getContent2(this.$route.query.text)
          // this.getContent(this.$route.query.text);
          // this.contentcolumnText = this.$route.query.item;
        }
      },
    },
  },
  methods: {
    getText() {
      for (var i = 0; i < this.contentList.length; i++) {
        if (this.$route.query.text == this.contentList[i].columnText) {
          this.remark = this.contentList[i].remark;
          this.styleIndex = i;
        }
      }
    },
    getList(item) {
      axios
          .get(
              "https://article.chenhaninfo.com/publish-article/sys/column/columnList",
              {}
          )
          .then(({ data }) => {
            if (data && data.code === 0) {
              for (let item2 of data.list) {
                if (item2.columnText === "区块链产品演示") {
                  this.contentList = item2.list;
                  this.getText();
                }
              }
            } else {
            }
          })
          .catch(function (error) {
            console.log(error);
          });
    },
    getContent2(item) {
      if (item.columnText!=undefined){
        this.selectType=item.columnText
      }else {
        this.selectType=item
      }
    },
    jump(item,val) {
      let url = item.url;
      if (url) {
        if (item.name == '演示资源下载') {
          console.log(item)
          // url = url.replace('http','https')
          window.open(url, "_self")
        }else if(item.name == '数字藏品'){
          if(val){
            window.open(val.texturl, "_blank")
          }else{
            url = 'https://pk-admin.trilliontrust.com/'
            window.open(url, "_blank")
          }
        }else {
          window.open(url, "_blank")
        }
      } else {
        this.$router.push({name: item.routerName})
      }
    },
  },
};
</script>
<style scoped lang="scss">
.nav {
  width: 100%;
  background-color: #fff;
  // padding: 0px 40px;
  .contents {
    //   width: 245px;
    background: #fafbfc;
    border-radius: 5px;
    border: 1px solid #d9e9ff;
    /*margin-left: 295px;*/
    //   margin-top: 35px;
    //   margin-bottom: 35px;
    //   padding-bottom: 44px;
    .image {
      float: right;
      position: relative;
      top: 8px;
      right: 20px;
    }
    .titleimg {
      cursor: pointer;
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #333333;
      // line-height: 25px;
      text-align: center;
      margin: 14px 0px;
    }
  }
  .box-big {
    width: 100%;
    // margin-left: 10%;
  }

  .top-title {
    padding-top: 2px;
    text-align: center;
    .title {
      font-size: 20px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 600;
      color: #282f3c;
      margin:10px 0;
      // margin-left: 96px;
      // float: left;
      // text-align: left !important;
    }

    .border {
      margin: 0 auto;
      width: 27px;
      height: 3px;
      // margin-top: 3px;
      background-color: #056dff;
      // margin-left: 85px;
    }
  }

  .text {
    // display: flex;
    flex-wrap: wrap;
    padding: 5px 5px;

    .row-line {
      //text-align: center;
    }
    .video-row {
      // padding-top: 82px;
      // height: 160px;
      width: 100%;
      min-height: 150px;
      // .product-img {
      //   // padding-top: 10px;
      //   .image {
      //     // padding-top: 10px;
      //   }
      // }
    }
    .product {
      // width: 385px;
      height: 150px;
      //background: #FAFBFC;
      border-radius: 5px;
      // cursor: pointer;
      margin: 20px 30px;

      .product-img {
        // width: 75px;
        // height: 75px;
        background: #f1f3f8;
        // border-radius: 50%;
        // margin: 17px 0px 18px 22px;
        // padding-top: 20px;

        .image {
          // width: 75px;
          // padding-top: 20px;
          // position: relative;
          // top: 31%;
          // left: 26%;
          // width: 35px;
          height: 75px;
        }
      }
    }

    .product-content {
      padding-top: 5px;
      flex-wrap: wrap;
      position: relative;
      height: 60px;

      .product-options-shelves {
        width: 50%;
        height: 33px;
        font-size: 14px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #999999;
        line-height: 33px;
        // position: absolute;
        bottom: 30px;
        left: 150px;
      }

      .product-title {
        font-size: 14px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #2a67e3;
      }

      .product-options {
        font-size: 10px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #333333;
      }

      .product-optionsnum {
        font-size: 10px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #333333;
        line-height: 20px;
        text-decoration: none;
      }
    }
  }
}
</style>
